// online-status.service.ts
import { Injectable, NgZone, Inject, PLATFORM_ID } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { BehaviorSubject, fromEvent, merge, of } from "rxjs";
import { map, startWith, distinctUntilChanged, shareReplay } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class OnlineStatusService {
  private onlineSubject = new BehaviorSubject<boolean>(true);
  online$ = this.onlineSubject.asObservable().pipe(shareReplay(1));

  constructor(@Inject(PLATFORM_ID) platformId: Object, private zone: NgZone) {
    if (isPlatformBrowser(platformId)) {
      const online$ = fromEvent(window, "online").pipe(map(() => true));
      const offline$ = fromEvent(window, "offline").pipe(map(() => false));

      // Initialize with current state
      const initial$ = of(navigator.onLine);

      this.zone.runOutsideAngular(() => {
        merge(initial$, online$, offline$)
          .pipe(
            startWith(navigator.onLine),
            distinctUntilChanged()
          )
          .subscribe((isOnline) => {
            // push back into Angular zone so template updates
            this.zone.run(() => this.onlineSubject.next(isOnline));
          });
      });
    }
  }
}
